import create from 'zustand';
import { getCashOnHand } from 'global/Securities/api/balance';

interface State {
  cashOnHand: number;
  isLoading: boolean;
}

interface Action {
  loadBalance(): Promise<void>;
  clear(): void;
}

type Store = State & Action;

const initialState: State = {
  cashOnHand: 0,
  isLoading: false,
};

export const useCashOnHandStore = create<Store>((set) => ({
  ...initialState,

  async loadBalance() {
    try {
      const response = await getCashOnHand();
      const { data } = response.data;
      set({ cashOnHand: data.available_cash_on_hand });
    } catch (error) {
      Promise.reject(error);
    }
  },

  clear() {
    set(initialState);
  },
}));
